import { IViolation } from 'app/model/base/annotation';
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { FileTypeDataset } from './file-type.dataset';

import { containWilcard, format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AzureBlob',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureBlobStorage_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureBlobStorage_DisplayText)
    ]
})
export class AzureBlobDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_WildcardPath,
        association: 'WILDCARD_PATH',
        templatable: true,
        constraint: {
            validator: AzureBlobDataset.validateWildcardPath
        }
    })
    public wildcardPath?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateWildcardPath(owner: AzureBlobDataset, value: string): IViolation[] | undefined {
        if (value != null) {
            if (owner instanceof AzureBlobDataset) {
                const container = (value || '').split('/')[0];
                if (containWilcard(container)) {
                    return [{
                        message: () => stringResources.WildcardBlobContainerError
                    }];
                }
            }
        }
        return undefined;
    }
}
